<template>
	<detail :is-edit="true" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'EditDevice',
		components: {Detail}
	}
</script>